<template>
  <a v-if="!page || isCurrentPage" href="#" @click.prevent="scrollToTarget">{{ props.text }}</a>
  <NuxtLink v-else :to="link">{{ props.text }}</NuxtLink>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import type { InternalLinkModel } from '~/models'
import { contentTypes } from '~/models'

const { expandAccordionIfNeeded } = useExpandAccordion()
const { scrollToElement } = useSmoothScroll()
const siteStore = useSiteStore()
const homePageStore = useHomePageStore()
const props = defineProps<{ model: InternalLinkModel; text: string }>()

const route = useRoute()

const page = ref<string>('')
if (props.model?.elements.page.value.length > 0) {
  page.value = siteStore.getUrlByCodename(props.model.elements.page.value[0])
}

const target = ref<any>(undefined)
if (props.model?.elements.element.value.length > 0) {
  const codename = props.model.elements.element.value[0]
  target.value = siteStore.getLinkedItem<any>(codename) ?? homePageStore.getLinkedItem<any>(codename)
}

const isCurrentPage = computed(() => page.value === route.path)

const link = computed(() => {
  if (!target.value || !page.value || isCurrentPage.value) return undefined

  const { itemid, ...rest } = route.query

  return {
    path: page.value,
    query: {
      ...rest,
      target: target.value.system?.id ?? target.value.system?.codename,
    },
  }
})

function scrollToTarget() {
  if (!target.value) return
  expandAccordionIfNeeded(target.value.system?.id)
  scrollToElement(target.value.system?.id ?? target.value.system?.codename)
}
</script>
